import React, { useEffect } from "react";
import ReactDOM from "react-dom";

const YOUTUBE_ID = "u31qwQUeGuM";

function VideoModal({ onClose }) {
  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onClose]);

  return ReactDOM.createPortal(
    <div
      style={{
        position: "fixed", inset: 0,
        background: "rgba(90,90,90,0.82)",
        zIndex: 99999,
        display: "flex", alignItems: "center", justifyContent: "center",
      }}
      onClick={onClose}
    >
      <div
        style={{
          position: "relative",
          width: "calc(100vw - 144px)",
          maxWidth: "1130px",
          aspectRatio: "16/9",
          background: "#D9D9D9",
          borderRadius: "8px",
          overflow: "hidden",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute", top: 12, right: 12, zIndex: 10,
            background: "rgba(0,0,0,0.5)", color: "#fff", border: "none",
            borderRadius: "50%", width: 36, height: 36, fontSize: 18,
            cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
          }}
        >✕</button>
        <iframe
          src={`https://www.youtube.com/embed/${YOUTUBE_ID}?autoplay=1`}
          title="BeszÉLJ videó"
          allow="autoplay; encrypted-media"
          allowFullScreen
          style={{ width: "100%", height: "100%", border: "none", display: "block" }}
        />
      </div>
    </div>,
    document.body
  );
}

export default VideoModal;
export { YOUTUBE_ID };